import { TraderDetailsPage } from 'features/traders';

export const AdminTraderDetails: React.FC = () => <TraderDetailsPage />;
